import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Sidebar from "./components/Navs/Sidebar";
import Header from "./components/Navs/Header";

// Public Pages
import LoginPage from "./pages/auth/Login";
import ForgotPasswordPage from "./pages/auth/ForgotPasswprd";
import ForgotPasswordOTP from "./pages/auth/ForgotPasswordOTP";
import ResetPasswordPage from "./pages/auth/ResetPassword";
import PasswordResetSuccess from "./pages/auth/PasswordResetSuccess";
import Layout from "./components/Layout";
import Dashboard from "./pages/private/dashboard";
import Settings from "./pages/private/settings";
import NotFound from "./routes/NotFoundPage";
import Earnings from "./pages/private/Earnings";
import Referrals from "./pages/private/Referrals";
import ProtectedRoute from "./components/ProtectedRoutes";
import SignupPage from "./pages/auth/Signup";
import { useAppDispatch } from "./redux/app/hooks";
import { fetchAllCountries } from "./redux/features/utilSlice";
import AuthSuccess from "./pages/auth/AuthSuccess";
import SignUpOtp from "./pages/auth/SignupOtp";
// import Rank from "./pages/private/Rank";

const App = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchAllCountries());
  }, [dispatch]);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/signup/verify-otp" element={<SignUpOtp />} />
        <Route path="/signup/success" element={<AuthSuccess />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route
          path="/forgot-password/verify-otp"
          element={<ForgotPasswordOTP />}
        />
        <Route
          path="/forgot-password/success"
          element={<PasswordResetSuccess />}
        />

        {/* Protected Routes */}
        <Route
          element={
            <ProtectedRoute>
              <Layout>
                <Sidebar />
                <Header />
              </Layout>
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/earnings" element={<Earnings />} />
          <Route path="/referrals" element={<Referrals />} />
          {/* <Route path="/rank-progression" element={<Rank />} /> */}
          <Route path="/settings" element={<Settings />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default App;
